define.alias("shared/components/shared/ui/past-post-limit-banner", "calendar/components/shared/ui/past-post-limit-banner");